import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { RouterState } from '@ngxs/router-plugin';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UpdateHideModal } from '@stores/popup-event/popup-event.actions';

interface PopupEventStateModel {
  campaignStartDate: number;
  campaignEndDate: number;
  hideModal: boolean;
}

@State({
  name: 'popup',
  defaults: {
    campaignStartDate: new Date('2022-03-04T07:00:00').getTime() / 1000,
    campaignEndDate: new Date('2023-03-05T18:00:00').getTime() / 1000,
    hideModal: false,
  },
})
@Injectable()
export class PopupEventState {
  @Selector([PopupEventState.hideModal, PopupEventState.isCampaignUp, RouterState.state])
  static shouldDisplay(hideModal: boolean, isCampaignUp: boolean, routerState: RouterStateSnapshot): boolean {
    const excludedUrls = [
      new RegExp(`\\/${FeaturesRoutingEnum.CEJ}`),
      new RegExp(`\\/${FeaturesRoutingEnum.EmployerSpace}`),
      new RegExp(`\\/${FeaturesRoutingEnum.Companies}`),
      new RegExp(`\\/${FeaturesRoutingEnum.Employers}\\/*`),
    ];
    const shouldDisplayOnUrl = !excludedUrls.find((urlRegExp) => routerState.url.match(urlRegExp));

    return isCampaignUp && !hideModal && shouldDisplayOnUrl;
  }

  @Selector([PopupEventState])
  static startDate(state: PopupEventStateModel): number {
    return state.campaignStartDate;
  }

  @Selector([PopupEventState])
  static endDate(state: PopupEventStateModel): number {
    return state.campaignEndDate;
  }

  @Selector([PopupEventState.startDate, PopupEventState.endDate])
  static isCampaignUp(startDate: number, endDate: number): boolean {
    const date = Math.round(Date.now() / 1000);
    return date > startDate && date < endDate;
  }

  @Selector([PopupEventState])
  static hideModal(state: PopupEventStateModel): boolean {
    return state.hideModal;
  }

  @Action(UpdateHideModal)
  updateHideModal(ctx: StateContext<PopupEventStateModel>, { hideModal }: UpdateHideModal): void {
    ctx.patchState({ hideModal });
  }
}
